import React from 'react';

import { isEmpty } from 'lodash';

import { useTranslation } from '@lt/localization';
import LTExtra from '../../../../components/LTExtra';
import ExtraPropTypes from '../../../Checkout/CheckoutRoutes/PackageCheckout/proptypes/extras';

const OfferExtras = ({ extras }) => {
  const { t } = useTranslation();
  if (isEmpty(extras)) return null;
  return (
    <div>
      <h4 className="like-h4">{t('filters.extras.title')}</h4>
      <ul>
        {extras.map((extraItem) => (
          <LTExtra isCompact key={extraItem.id} {...extraItem} />
        ))}
      </ul>
    </div>
  );
};

OfferExtras.propTypes = {
  extras: ExtraPropTypes.items,
};

export default OfferExtras;
